"use strict";

exports.__esModule = true;
exports.default = keys;
var _isObject = _interopRequireDefault(require("./isObject.js"));
var _setup = require("./_setup.js");
var _has = _interopRequireDefault(require("./_has.js"));
var _collectNonEnumProps = _interopRequireDefault(require("./_collectNonEnumProps.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Retrieve the names of an object's own properties.
// Delegates to **ECMAScript 5**'s native `Object.keys`.
function keys(obj) {
  if (!(0, _isObject.default)(obj)) return [];
  if (_setup.nativeKeys) return (0, _setup.nativeKeys)(obj);
  var keys = [];
  for (var key in obj) if ((0, _has.default)(obj, key)) keys.push(key);
  // Ahem, IE < 9.
  if (_setup.hasEnumBug) (0, _collectNonEnumProps.default)(obj, keys);
  return keys;
}